import { Check, Loader2 } from "lucide-react";
import { auth } from "../firebase"; 
import { useState } from "react";

export default function Checkout() {
  const [loading, setLoading] = useState(false);
  const handleStripeCheckout = async () => {
    try {
      setLoading(true);
      const user = auth.currentUser;
      if (!user) return alert("Debes iniciar sesión para continuar.");
      const res = await fetch("https://us-central1-noltrade.cloudfunctions.net/api/stripe/session", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: user.email }),
      });
  
      const data = await res.json();
  
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert("Hubo un problema al redirigir a Stripe.");
        setLoading(false);
      }
    } catch (err) {
      console.error("Error iniciando Stripe Checkout:", err);
      alert("Error al procesar el pago. Intentalo de nuevo más tarde.");
      setLoading(false);
    }
  };
  
  

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-white to-[#fffceb] px-4 py-12">
      <div className="bg-white shadow-xl rounded-xl max-w-2xl w-full p-8">
        <div className="text-center mb-6">
        <h1 className="text-3xl font-bold text-gray-800">
            Suscripción a <span className="text-yellow-600">Premium</span>
            </h1>
          <p className="text-gray-500 text-sm mt-1">Acceso completo y sin límites a la plataforma</p>
        </div>

        <div className="border rounded-lg p-6 mb-6 bg-gray-50">
          <div className="flex items-center justify-between mb-4">
            <span className="text-lg font-semibold text-gray-700">Noltrade Premium</span>
            <div className="text-right">
              <span className="text-yellow-600 font-bold text-xl">49,99€ / mes</span>
              <div className="text-[11px] text-gray-500 italic">IVA incluido</div>
            </div>

          </div>
          <ul className="text-sm text-gray-600 space-y-2">
            <li className="flex items-center gap-2">
              <Check className="text-yellow-500 w-4 h-4" />
              Acceso completo a todos los listados
            </li>
            <li className="flex items-center gap-2">
              <Check className="text-yellow-500 w-4 h-4" />
              Ver compradores y contactar sin límites
            </li>
            <li className="flex items-center gap-2">
              <Check className="text-yellow-500 w-4 h-4" />
              Acceso prioritario a oportunidades
            </li>
            <li className="flex items-center gap-2">
              <Check className="text-yellow-500 w-4 h-4" />
              Dashboard privado
            </li>
            <li className="flex items-center gap-2">
              <Check className="text-yellow-500 w-4 h-4" />
              Informes de ofertas
            </li>
            <li className="flex items-center gap-2">
              <Check className="text-yellow-500 w-4 h-4" />
              Histórico financiero
            </li>
            <li className="flex items-center gap-2">
              <Check className="text-yellow-500 w-4 h-4" />
              Posibilidad de solicitar reuniones privadas con el vendedor
            </li>
            <li className="flex items-center gap-2">
              <Check className="text-yellow-500 w-4 h-4" />
              Activos clave y contratos
            </li>
          </ul>
        </div>
        <button
          onClick={handleStripeCheckout}
          disabled={loading}
          className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-3 rounded-lg text-lg transition flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? (
            <>
              <Loader2 className="w-5 h-5 animate-spin" />
              Redirigiendo a Stripe...
            </>
          ) : (
            "Proceder al pago seguro"
          )}
        </button>


        <p className="text-xs text-gray-400 text-center mt-3">
          Cancelable en cualquier momento. Pagos seguros vía Stripe.
        </p>
      </div>

      <div className="text-center text-xs text-gray-400 mt-6">
        © {new Date().getFullYear()} Noltrade · <a href="/legal/terminos" className="underline">Términos</a> · <a href="/legal/privacidad" className="underline">Privacidad</a>
      </div>
    </div>
  );
}
